import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["url", "className", "eventCategory", "eventAction", "eventLabel", "children", "target", "rel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React from 'react';
import classNames from 'classnames';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const ExternalLink = _ref => {
  let {
      url,
      className,
      eventCategory,
      eventAction,
      eventLabel,
      children,
      target,
      rel
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const props = _objectSpread({
    href: url,
    target,
    rel,
    className: classNames(className, {
      [style.ExternalLink]: !className
    })
  }, otherProps);
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    onClick: eventCategory ? () => trackClickEvent(eventCategory, eventAction, eventLabel) : undefined
  }, props), {}, {
    "data-id": "external-link_index_ExternalLink_a",
    children: children
  }));
};
ExternalLink.defaultProps = {
  target: '_blank',
  rel: 'noopener noreferrer'
};
export default ExternalLink;